import { eventSchemaId } from '../fixture-ids';

export const eventSchemaLegacyAlternates = {};

export const eventSchemaLegacyFixtures = {
  EVENT_SCHEMA_DELETED: {
    action: 'EVENT_SCHEMA_DELETED',
    debugData: {
      eventSchemaId,
      name: 'checkout_completed',
      description: 'Fires when a checkout completes successfully',
    },
  },
};
